import { Injectable } from '@angular/core';
import { SnAuthUser } from '@insight/serenity-auth';

@Injectable()
export class UserService {

  constructor() {

  }

  public _authUser: SnAuthUser;

  get authUser() {
    if (!this._authUser) {
      try {
        const tUser = JSON.parse(localStorage.getItem('authUser'));
        if (tUser) {
          this._authUser = tUser;
        } else {
          // console.log('%cCouldn\'t get a user.', 'color:red;');
          return {displayName: '', partyMemberId: '', partyMemberType: '', firstName: '', lastName: '', title: '', position: '', email: '', dataLineageId: '', identityProviderId: ''} as SnAuthUser;
        }
      } catch (e) {
        // console.log('%cCouldn\'t get a user.', 'color:red;');
        return {displayName: '', partyMemberId: '', partyMemberType: '', firstName: '', lastName: '', title: '', position: '', email: '', dataLineageId: '', identityProviderId: ''} as SnAuthUser;
      }
    }
    return this._authUser;
  }

  set authUser(authUser: SnAuthUser) {
    this._authUser = authUser;
    localStorage.setItem('authUser', JSON.stringify(authUser));
  }

  getUserName() {
    if (this._authUser) {
      const first = this._authUser.firstName[0];
      return first + this._authUser.lastName;
    }
    return '';
  }
}
